import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '../../public/locales/en/common.json';
import enCompany from '../../public/locales/en/company.json';
import enFlow from '../../public/locales/en/flow.json';
import enQuestionnaire from '../../public/locales/en/questionnaire.json';
import enScreens from '../../public/locales/en/screens.json';
import thCommon from '../../public/locales/th/common.json';
import thCompany from '../../public/locales/th/company.json';
import thFlow from '../../public/locales/th/flow.json';
import thQuestionnaire from '../../public/locales/th/questionnaire.json';
import thScreens from '../../public/locales/th/screens.json';
import { chosenLanguage } from './languageChoice';

/**
 * The copy lives in `public/locales/<lng>/<ns>.json` (project convention: i18n
 * is JSON under public), split by surface so a translator can take one file.
 *
 * The files are split for AUTHORING; they are merged into ONE i18next namespace
 * here. `useTranslation()` binds its `t` to a SINGLE namespace — the first one —
 * no matter how many are listed in `defaultNS` or passed to the hook (only the
 * instance-level `i18n.t` walks a list). Real namespaces would therefore force
 * an `ns:` prefix on every call site, and many keys are computed at runtime
 * (`t(messageKey)`, `translateState(t, prefix, …)`, `t(`flow.event.${action}`)`)
 * where no prefix can be threaded through.
 *
 * Top-level key names inside each file are unchanged from the old single
 * dictionary and are disjoint across files, so every existing lookup still hits;
 * `.claudecode/vfy/2026-09-06-locale-parity.mjs` fails on a collision.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { ...enFlow, ...enScreens, ...enCommon, ...enCompany, ...enQuestionnaire } },
    th: { translation: { ...thFlow, ...thScreens, ...thCommon, ...thCompany, ...thQuestionnaire } },
  },
  // A choice the applicant made earlier on this tab survives a reload; the
  // link's own language is applied later, once the snapshot says what it is.
  lng: chosenLanguage() ?? 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
